import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { useCallback as u } from "react";
import f from "clsx";
import { getStylesFromSelectors as y, createPureSelectors as h } from "../../utils/classNameSelectors.js";
import "../../utils/sectionPreview.js";
import { Button as S } from "../Button/Button.js";
import "next/link";
import "../../_chunks/RadioRatingStarButton.Brs_PIli.js";
import "js-cookie";
import "../Combobox/Combobox.js";
import "../Datepicker/Datepicker.js";
import { Typography as m } from "../Typography/Typography.js";
import "@portabletext/react";
import "../Grid/Col/Col.js";
import "react-is";
import "../IconButton/IconButton.js";
import "next/image";
import "../Input/Input.js";
import "@hookform/error-message";
import "../Modal/constants.js";
import "../Modal/ModalContent.js";
import "../Modal/ModalFooter.js";
import "../Modal/ModalHeader.js";
import "../Modal/ModalContext.js";
import "../RadioButton/RadioButton.js";
import "../Switch/Switch.js";
import '../../_assets/EmptyBlockDeprecated.ZJkjs-cr.css';const g = "_empty_18d71_44", v = "_icon_18d71_54", z = "_info_18d71_63", N = "_btn_18d71_77", o = {
  empty: g,
  icon: v,
  info: z,
  "xxs-mobile": "_xxs-mobile_18d71_70",
  btn: N,
  "xxs-desktop": "_xxs-desktop_18d71_80",
  "xs-mobile": "_xs-mobile_18d71_89",
  "xs-desktop": "_xs-desktop_18d71_99",
  "s-mobile": "_s-mobile_18d71_108",
  "s-desktop": "_s-desktop_18d71_118",
  "ssm-mobile": "_ssm-mobile_18d71_127",
  "ssm-desktop": "_ssm-desktop_18d71_137",
  "sm-mobile": "_sm-mobile_18d71_146",
  "sm-desktop": "_sm-desktop_18d71_156",
  "m-mobile": "_m-mobile_18d71_165",
  "m-desktop": "_m-desktop_18d71_175",
  "xm-mobile": "_xm-mobile_18d71_184",
  "xm-desktop": "_xm-desktop_18d71_194",
  "l-mobile": "_l-mobile_18d71_203",
  "l-desktop": "_l-desktop_18d71_213",
  "xl-mobile": "_xl-mobile_18d71_222",
  "xl-desktop": "_xl-desktop_18d71_232",
  "xxl-mobile": "_xxl-mobile_18d71_241",
  "xxl-desktop": "_xxl-desktop_18d71_251",
  "slide-in-out": "_slide-in-out_18d71_1",
  "fade-in-out": "_fade-in-out_18d71_1"
}, Z = ({
  className: s,
  href: _,
  externalHref: d,
  icon: l,
  title: r,
  text: p,
  btnName: n,
  onClick: t,
  size: c = "mobile",
  btnSize: x = "medium",
  btnIcon: a
}) => {
  const b = u(() => {
    t && t();
  }, [t]), k = y(h(c, "mobile"), o);
  return /* @__PURE__ */ i("section", { className: f(s, o.empty, k), children: [
    /* @__PURE__ */ e("span", { className: o.icon, children: l }),
    /* @__PURE__ */ i("div", { className: o.info, children: [
      /* @__PURE__ */ e(m, { variant: "portalSubtitleBold", size: "1", noPadding: !0, color: "black-new", children: r }),
      /* @__PURE__ */ e(m, { variant: "portalText", size: "1", noPadding: !0, color: "black-new", children: p })
    ] }),
    /* @__PURE__ */ e(
      S,
      {
        theme: "new",
        rounded: !0,
        className: o.btn,
        variant: "primary",
        size: x,
        icon: a,
        href: _,
        externalHref: d,
        onClick: b,
        children: n
      }
    )
  ] });
};
export {
  Z as EmptyBlockDeprecated
};
